import { Field, reduxForm } from "redux-form";
import { Dashboard } from "components";
import { Button, Input } from "expano-components";
import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const ChannelCampaign = ({
  channel_id,
  handleClose,
  pristine,
  invalid,
  handleSubmit,
  refetch,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}`,
    onSuccess: () => {
      refetch();
      handleClose();
    },
  });

  const onSubmit = ({
    min_roas,
    max_roas,
    min_average_use_daily_budget,
    max_average_use_daily_budget,
  }) =>
    update({
      min_roas,
      max_roas,
      min_average_use_daily_budget,
      max_average_use_daily_budget,
    });

  return (
    <Dashboard
      header={{
        title: "Ustawienia kampanii",
        icon: "info",
      }}
      footer={
        <Button
          type="save"
          text="Zapisz"
          disabled={invalid || pristine || is_updating}
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field name="max_roas" label="Wysoki ROAS" component={InputField} />
        <Field name="min_roas" label="Niski ROAS" component={InputField} />
        <Field
          name="max_average_use_daily_budget"
          label="Średnie dzienne wykorzystanie budżetu - wysokie"
          component={InputField}
          postfix="%"
        />
        <Field
          name="min_average_use_daily_budget"
          label="Średnie dzienne wykorzystanie budżetu - niskie"
          component={InputField}
          postfix="%"
        />
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.min_roas) {
    errors.min_roas = "Pole wymagane!";
  }

  if (!values.max_roas) {
    errors.max_roas = "Pole wymagane!";
  }

  return errors;
};

export default reduxForm({
  form: "channel_campaign_data",
  validate,
})(ChannelCampaign);
